// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s5GuJ","colMin":"styles_colMin__3Or5y"};